(function () {
  "use strict";
  if (window.REMSGutsCartPreview) { window.REMSGutsCartPreview.init(); return; }

  var cache = {}, instance = 0;
  function safeColor(value, fallback) { return /^#[0-9a-f]{3,8}$/i.test(String(value || "")) ? value : fallback; }
  function setSvgVisible(item, visible, clearOpacity) {
    item.toggleAttribute("hidden", !visible);
    if (visible) item.removeAttribute("display"); else item.setAttribute("display", "none");
    if (visible && clearOpacity) item.removeAttribute("opacity");
  }
  function namespaceSvgDefinitions(svg, namespace) {
    var prefix = "rems-" + String(namespace || "seat").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "") + "-", replacements = {};
    Array.prototype.forEach.call(svg.querySelectorAll("defs [id]"), function (item) {
      replacements[item.id] = prefix + item.id;
      item.id = replacements[item.id];
    });
    Array.prototype.forEach.call(svg.querySelectorAll("*"), function (item) {
      Array.prototype.forEach.call(item.attributes || [], function (attribute) {
        var value = attribute.value.replace(/url\((["']?)#([^)'\"]+)\1\)/g, function (match, quote, id) {
          return replacements[id] ? "url(" + quote + "#" + replacements[id] + quote + ")" : match;
        });
        if (value.charAt(0) === "#" && replacements[value.slice(1)]) value = "#" + replacements[value.slice(1)];
        if (value !== attribute.value) item.setAttributeNS(attribute.namespaceURI, attribute.name, value);
      });
    });
  }
  function asset(url) {
    if (!cache[url]) cache[url] = fetch(url, {credentials:"same-origin"}).then(function (response) { if (!response.ok) throw new Error("Seat preview unavailable"); return response.text(); }).then(function (markup) {
      if (/<(?:script|foreignObject|iframe)\b/i.test(markup)) throw new Error("Unsafe seat preview");
      return markup;
    });
    return cache[url];
  }
  function render(target) {
    if (target.getAttribute("data-guts-preview-ready")) return;
    target.setAttribute("data-guts-preview-ready", "loading");
    asset(target.getAttribute("data-src")).then(function (markup) {
      var template = document.createElement("template"); template.innerHTML = markup.trim();
      var svg = template.content.querySelector("svg");
      if (!svg || !(svg.id === "guts-seat-left" || svg.querySelector("#guts-seat-left"))) throw new Error("Invalid seat preview");
      namespaceSvgDefinitions(svg, "cart-" + (++instance));
      svg.setAttribute("role", "img"); svg.setAttribute("aria-label", "Configured Guts Racing seat");
      target.style.setProperty("--guts-side", safeColor(target.getAttribute("data-side"), "#ffffff"));
      target.style.setProperty("--guts-center", safeColor(target.getAttribute("data-center"), "#000000"));
      target.style.setProperty("--guts-accent", safeColor(target.getAttribute("data-rib"), "#cb333b"));
      var style = target.getAttribute("data-style") || (target.getAttribute("data-ribs") === "1" ? "ribbed" : "non-ribbed"), ballistic = target.getAttribute("data-ballistic") === "1";
      var sideLogo = target.getAttribute("data-side-logo") === "1", topLogo = target.getAttribute("data-top-logo") || "guts";
      svg.querySelectorAll("[data-guts-ribs]").forEach(function (item) { setSvgVisible(item, style === "ribbed"); });
      svg.querySelectorAll("[data-guts-rf1]").forEach(function (item) { setSvgVisible(item, style === "rf1"); });
      svg.querySelectorAll("[data-guts-ballistic-panel]").forEach(function (item) { setSvgVisible(item, ballistic); });
      svg.querySelectorAll("[data-guts-ballistic-texture]").forEach(function (item) { setSvgVisible(item, ballistic); });
      svg.querySelectorAll("[data-guts-ballistic-shadow]").forEach(function (item) { setSvgVisible(item, ballistic); });
      svg.querySelectorAll("[data-guts-side-logo]").forEach(function (item) { setSvgVisible(item, sideLogo); });
      svg.querySelectorAll("[data-guts-top-logo]").forEach(function (item) { setSvgVisible(item, item.getAttribute("data-guts-top-logo") === topLogo, true); });
      target.replaceChildren(svg); target.setAttribute("data-guts-preview-ready", "true");
    }).catch(function () { target.setAttribute("data-guts-preview-ready", "error"); });
  }
  function init() { Array.prototype.forEach.call(document.querySelectorAll("[data-guts-cart-preview]"), render); }
  window.REMSGutsCartPreview = {init:init};
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  new MutationObserver(init).observe(document.documentElement, {childList:true,subtree:true});
}());
